import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import TasksView from '../views/TasksView.vue';
import ReferralView from '../views/ReferralView.vue';
import SettingsView from '../views/SettingsView.vue';

const routes = [
  { path: '/', component: HomeView },
  { path: '/tasks', component: TasksView },
  { path: '/referral', component: ReferralView },
  { path: '/settings', component: SettingsView }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// Navigation guard to ensure query parameters are always present
router.beforeEach((to, from, next) => {
  const telegramId = to.query.telegram_id || from.query.telegram_id;
  const username = to.query.username || from.query.username;
  const ref = to.query.ref || from.query.ref;

  if (telegramId && username && ref) {
    if (!to.query.telegram_id || !to.query.username || !to.query.ref) {
      next({
        path: to.path,
        query: {
          telegram_id: telegramId,
          username: username,
          ref: ref
        },
        replace: true // Prevents infinite loop when using the back button
      });
    } else {
      next();
    }
  } else {
    if (to.path !== '/') {
      next({
        path: '/',
        query: {
          telegram_id: telegramId || '',
          username: username || '',
          ref: ref || ''
        }
      });
    } else {
      next();
    }
  }
});

// Global error handling
router.onError(error => {
  console.error('Router error:', error);

  // Redirect to home page with telegram_id query parameter on error
  const telegramId = router.currentRoute.value.query.telegram_id || '';
  router.replace({
    path: '/',
    query: { telegram_id: telegramId }
  });
});

export default router;
